import { initializeApp } from "firebase/app";
import { getDatabase, Database } from "firebase/database";
import { getFirestore, Firestore } from "firebase/firestore";
import { getAuth, Auth } from "firebase/auth";

// CREDENCIAIS DO FIREBASE
const firebaseConfig = {
  apiKey: "AIzaSyAGPJPMf4aLX7SO0t-jpu1JtmOi79jq9dw",
  authDomain: "abh-motoboys.firebaseapp.com",
  databaseURL: "https://abh-motoboys-default-rtdb.firebaseio.com", // Realtime Database
  projectId: "abh-motoboys",
  storageBucket: "abh-motoboys.firebasestorage.app",
  messagingSenderId: "975475587076",
  appId: "1:975475587076:web:9e2a3cd33bb88135c3dd51"
};

const isConfigured = Boolean(firebaseConfig.databaseURL && firebaseConfig.databaseURL.startsWith("http"));

// Inicialização da aplicação Firebase
export const app = initializeApp(firebaseConfig);

// Realtime Database (usado exclusivamente para a leitura das tabelas e preços de cotação online - quoteConfig)
export const db: Database | null = isConfigured ? getDatabase(app) : null;

// Cloud Firestore (utilizado para usuários, endereços salvos, corridas e chat de mensagens)
export const firestore: Firestore = getFirestore(app);

// Firebase Authentication (Barreira de login da Área do Cliente)
export const auth: Auth = getAuth(app);

// Constantes de Nomes de Coleções e Subcoleções no Firestore
export const FIRESTORE_COLECOES = {
  USUARIOS: 'usuarios',
  ENDERECOS_SALVOS: 'enderecos_salvos',
  CORRIDAS: 'corridas',
  MENSAGENS: 'mensagens',
  CONFIGURACOES: 'configuracoes'
} as const;

// Exportação de tipos e utilitários do Firestore
export * from './types/firestore';


